import Vue from 'vue'
import Toast from '@/components/Toast.vue'

const ToastPlugin = {
  install(Vue) {
    // 1. 创建Toast构造器
    const ToastConstructor = Vue.extend(Toast)
    
    // 2. 实例化并挂载
    const toastInstance = new ToastConstructor({
      el: document.createElement('div')
    })
    document.body.appendChild(toastInstance.$el)

    // 3. 添加全局方法
    Vue.prototype.$toast = {
      show: (msg, type, duration) => toastInstance.show(msg, type, duration),
      info: (msg, duration = 3000) => toastInstance.show(msg, 'info', duration),
      success: (msg, duration = 3000) => toastInstance.show(msg, 'success', duration),
      error: (msg, duration = 3000) => toastInstance.show(msg, 'error', duration),
      warning: (msg, duration = 3000) => toastInstance.show(msg, 'warning', duration)
    }
  }
}

export default ToastPlugin


// WEBPACK FOOTER //
// ./src/plugins/toast.js